import { render, staticRenderFns } from "./ModalParticipantService.vue?vue&type=template&id=2061d1ed&scoped=true"
import script from "./ModalParticipantService.vue?vue&type=script&lang=js"
export * from "./ModalParticipantService.vue?vue&type=script&lang=js"
import style0 from "./ModalParticipantService.vue?vue&type=style&index=0&id=2061d1ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061d1ed",
  null
  
)

export default component.exports